export const groupBy = (array, key) => {
  if (!Array.isArray(array) || !key) return {};

  try {
    return array.reduce((rv, x) => {
      if (typeof x !== "object" || x === null) {
        throw new TypeError("Invalid array item for groupBy");
      }
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  } catch (_e) {
    return {};
  }
};

export const uniqueBy = (array, key) => {
  if (!Array.isArray(array) || !key) return [];

  try {
    const seen = new Set();
    return array.filter(item => {
      if (typeof item !== "object" || item === null) {
        throw new TypeError("Invalid array item for uniqueBy");
      }
      const val = item[key];
      if (seen.has(val)) {
        return false;
      }
      seen.add(val);
      return true;
    });
  } catch (_e) {
    return [];
  }
};
